import { bind } from '@react-rxjs/core';
import { map, merge, of, switchMap, take, tap } from 'rxjs';
import { MenuConfig } from '../types/menu';
import { createSignal } from '@react-rxjs/utils';
import { features$ } from './features';
import { menuOptions } from '../pages/CustomiseMenu/menuOptions';

const STORAGE_KEY = 'custom-menu';
const defaultConfig: MenuConfig = [
  'home',
  'malfunctions',
  'history',
  'reservations',
  'logbook',
];

export const [setMenuConfig$, setMenuConfig] = createSignal<MenuConfig>();
export const [useMenuConfig] = bind(
  merge(
    of(window.localStorage.getItem(STORAGE_KEY)).pipe(
      map((res) => {
        try {
          return JSON.parse(res ?? '') as MenuConfig;
        } catch (e) {
          return defaultConfig;
        }
      })
    ),
    setMenuConfig$.pipe(
      tap((config) => {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
      })
    )
  ).pipe(
    switchMap((config) =>
      features$.pipe(
        take(1),
        map((features) =>
          config.filter((id) => {
            const option = menuOptions.get(id);
            if (!option) {
              return false;
            }
            return option?.feature ? features.includes(option.feature) : true;
          })
        )
      )
    )
  )
);

export const [useMenuOptions] = bind(
  of(Array.from(menuOptions.values())).pipe(
    switchMap((options) =>
      features$.pipe(
        take(1),
        map((features) =>
          options.filter(({ feature }) => {
            return feature ? features.includes(feature) : true;
          })
        )
      )
    )
  )
);
